module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column resumo-subsidio-mcmv",
    attrs: {
      "id": "dashboardMcmv"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deveExibirDados),
      expression: "deveExibirDados"
    }],
    staticClass: "cabecalho-dashboard-mcmv container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading
    }
  }), _vm._v(" "), _c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-margem-inferior-pequena"
  }, [_c('div', {
    staticClass: "investimento-inicial"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "valor"
  }, [_c('p', [_vm._v(_vm._s(_vm.valorTotalDoProjeto))]), _vm._v(" "), _c('span', [_vm._v("\n            Investimento de programa\n            "), _c('strong', [_vm._v(_vm._s(this.dadosDoFiltro.projetoNome))])])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deveExibirDados),
      expression: "deveExibirDados"
    }]
  }, [_c('div', {
    staticClass: "card-container"
  }, _vm._l((_vm.dadosPorStatus), function(status) {
    return _c('div', {
      key: status.nome
    }, [_c('DashCard', {
      attrs: {
        "headerColor": status.classeCss,
        "status": status.nome,
        "quantidadeDeSolicitacoes": status.quantidade,
        "valor": status.valorFormatado,
        "porcentagem": status.valorPercentual
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "progress-mcmv progress-saldo-total-mcmv"
  }, _vm._l((_vm.dadosPorStatus), function(status) {
    return _c('div', {
      class: ['progress-bar-mcmv', status.classeCss],
      style: ({
        width: ((status.valorPercentual) + "%")
      }),
      attrs: {
        "role": "progressbar",
        "aria-valuenow": "60",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('div', {
    staticClass: "grafico-familias-mcmv u-margem-superior-media"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "area-graficos-mcmv"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "legenda-mcmv"
  }, [_c('ul', _vm._l((_vm.dadosDaLegendaParaResumo.filter(
    function (legenda) { return legenda.deveMostrarNaLista; }
  )), function(legenda) {
    return _c('li', [_c('span', {
      staticClass: "figura",
      style: ({
        background: ("" + (legenda.cor))
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "titulo"
    }, [_vm._v("\n                      " + _vm._s(legenda.quantidade) + "\n                      " + _vm._s(legenda.quantidade === 1 ? "família" : "famílias") + "\n                      "), _c('p', [_vm._v(_vm._s(legenda.nomeDaFaixa))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "total-atendido-mcmv"
  }, [_vm._v("\n                  Total de\n                  "), _c('strong', [_vm._v("\n                    " + _vm._s(_vm.totalDeFamiliasAtendidas) + "\n                    " + _vm._s(_vm.totalDeFamiliasAtendidas === 1 ? "família" : "famílias") + "\n                  ")]), _vm._v("\n                  já atendidas\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('div', {
    staticClass: "grafico-familias-mcmv u-margem-superior-media"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "area-graficos-mcmv"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "legenda-mcmv"
  }, [_c('ul', _vm._l((_vm.dadosDaLegendaParaRecursos), function(legenda) {
    return _c('li', [_c('span', {
      staticClass: "figura",
      style: ({
        background: ("" + (legenda.cor))
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "titulo"
    }, [_vm._v("\n                      " + _vm._s(legenda.valor) + "\n                      "), _c('p', [_vm._v(_vm._s(legenda.nomeDaFaixa))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "total-atendido-mcmv"
  }, [_vm._v("\n                  Total de\n                  "), _c('strong', [_vm._v(_vm._s(_vm.totalDeRecursosDisponiveis))]), _vm._v(" restantes\n                ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "print"
  }, [_c('div', {
    staticClass: "printar-data"
  }, [_vm._v("\n        Impresso em " + _vm._s(new Date().toLocaleDateString("pt-BR")) + "\n      ")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icone"
  }, [_c('i', {
    staticClass: "fal fa-sack-dollar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_sem-preenchimento botao_grande",
    attrs: {
      "type": "button",
      "onclick": "window.print()"
    }
  }, [_c('i', {
    staticClass: "fal fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Imprimir\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icone-familia"
  }, [_c('i', {
    staticClass: "fal fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Famílias já atendidas por faixa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grafico-mcmv"
  }, [_c('canvas', {
    attrs: {
      "id": "graficoDeResumo",
      "width": "300px",
      "height": "300px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icone-familia"
  }, [_c('i', {
    staticClass: "fa-light fa-chart-pie-simple-circle-dollar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Recursos ainda disponíveis por faixa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grafico-mcmv"
  }, [_c('canvas', {
    attrs: {
      "id": "graficoDeRecursosDisponiveis",
      "width": "300px",
      "height": "300px"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eafc658e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eafc658e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/DashboardParaMcmvCidades.vue
// module id = 1146
// module chunks = 1